export const favoriteDocumentsReducer = (state:DocumentObject[], action:any) => {
    switch (action.type) {
        case 'SET_FAVORITEDOCUMENTS':
            state = action.payload;
            return state;
        case 'RESET_STATE':
            state = []
            return state;
        default:
            return state || [];
    }
}